import { render, staticRenderFns } from "./Sayfa.vue?vue&type=template&id=4b287006&scoped=true&"
import script from "./Sayfa.vue?vue&type=script&lang=js&"
export * from "./Sayfa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b287006",
  null
  
)

export default component.exports